import { mapGetters } from 'vuex'

export default {

    computed: {
        ...mapGetters({
            isReconnectPopup: 'isReconnectPopup',
            currentQuizIndex: 'currentQuizIndex',
            masterPlayingAs: 'player/masterPlayingAs'
        })
    },

    data () {
        return {

            showMasterPopup: false,
            masterPopupIcon: '',
            masterPopupTitle: '',
            masterPopupMessage: '',
            masterOkButton: '',
            masterRetryFailMessage: '',

            showPlayerPopup: false,
            playerPopupIcon: '',
            playerPopupTitle: '',
            playerPopupMessage: '',
            playerOkButton: '',
            playerRetryFailMessage: '',

            lastCheckUserAt: null,
            lastWaitUserAt: null,

            watchMasterActiveTimer: null,
            lastMasterPingAt: null,

            allPlayers: {},
            currentPlayers: 0
        }
    },

    mounted () {

        window.removeEventListener('socket-reconnect', () => {})
        window.removeEventListener('socket-reconnect-attempt', () => {})

        window.addEventListener('socket-reconnect', this.onSocketReconnect)
        window.addEventListener('socket-reconnect-attempt', this.onSocketReconnectAttempt)
    },

    watch: {
        isReconnectPopup (val) {
            if (val) {
                this.showMasterPopup = false
                this.showPlayerPopup = false
            }
        }
    },

    methods: {
        onSocketReconnect () {
            this.$store.commit('setIsReconnectPopup', false)
            let playerInfo = this.$store.getters['userPlayingInfo']
            playerInfo.quizIndex = this.currentQuizIndex

            this.resumeTimeAndProgress()
            this.$socket.emit('user_reconnect', playerInfo)
        },

        onSocketReconnectAttempt() {

            this.pauseTimeAndProgress()
            this.$store.commit('setIsReconnectPopup', true)
        },

        checkMasterActive () {

            if (this.isPlayTogether && this.masterPlayingAs == 'player') {
                return
            }

            const watchTimeoutSec = 3

            this.watchMasterActiveTimer = setInterval(() => {

                if (!this.lastMasterPingAt) {
                    return
                }

                const currentTime = new Date()
                const waitInSec = (currentTime - this.lastMasterPingAt) / 1000

                if (this.lastMasterPingAt && waitInSec > watchTimeoutSec && !this.showPlayerPopup && !this.isPromptReconnect()) {

                    this.lastMasterPingAt = null

                    this.pauseTimeAndProgress()

                    return this.playerPopup({
                        icon: 'fas fa-user-tie',
                        title: this.$t('socket_check_qm_title'),
                        message: this.$t('socket_check_qm_message'),
                        failMessage: this.$t('socket_check_qm_fail_message'),
                        okButton: this.$t('socket_end_quiz')
                    }).show()
                }

                if (this.lastMasterPingAt && waitInSec < watchTimeoutSec && this.showPlayerPopup) {
                    this.playerPopup().hide()
                    this.resumeTimeAndProgress()
                }

            }, 1000)
        },

        getCurrentUser () {

            const timeoutSec = 2

            this.watchUserTimer = setInterval(() => {

                var activePlayers = {}
                const currentTime = new Date()

                for (let i in this.allPlayers) {
                    let time = this.allPlayers[i]

                    if ((currentTime - time) / 1000 < timeoutSec) {
                        activePlayers[i] = this.allPlayers[i]
                    }
                }

                const userLength = Object.keys(activePlayers).length
                const waitInSec = (currentTime - this.lastWaitUserAt) / 1000

                this.currentPlayers = Object.keys(activePlayers).length

                if (this.lastWaitUserAt && waitInSec < 5) {

                    this.$socket.emit('master_ping_user', {
                        room: this.code
                    })

                    return
                }

                if (!userLength && !this.showMasterPopup && this.lastCheckUserAt && !this.isPromptReconnect()) {

                    // If no user in room, when end quiz
                    if (this.$route.name === 'master-result' && this.isEndQuiz) {
                        clearInterval(this.watchUserTimer)
                        this.handleClickEnd()
                        return
                    }

                    return this.masterPopup({
                        icon: 'fas fa-user-slash',
                        title: this.$t('socket_no_user_in_quiz_title'),
                        message: this.$t('socket_no_user_in_quiz_message'),
                        okButton: this.$t('socket_end_quiz'),
                        failMessage: this.$t('socket_no_user_fail_message'),
                    }).show()
                }

                if (userLength && this.showMasterPopup) {
                    this.masterPopup().hide()
                }

                this.$socket.emit('master_ping_user', {
                    room: this.code
                })

            }, 1000)
        },

        masterPopup (payload) {
            var self = this
            return {
                show() {
                    self.showMasterPopup = true
                    self.masterPopupIcon = payload.icon
                    self.masterPopupTitle = payload.title
                    self.masterPopupMessage =  payload.message
                    self.masterOkButton = payload.okButton
                    self.masterRetryFailMessage = payload.failMessage
                },

                hide() {
                    self.showMasterPopup = false
                    self.masterPopupIcon = ''
                    self.masterPopupTitle = ''
                    self.masterPopupMessage = ''
                    self.masterOkButton = ''
                    self.masterRetryFailMessage = ''
                }
            }
        },

        playerPopup (payload) {
            var self = this
            return {
                show() {
                    self.showPlayerPopup = true
                    self.playerPopupIcon = payload.icon
                    self.playerPopupTitle = payload.title
                    self.playerPopupMessage =  payload.message
                    self.playerOkButton = payload.okButton
                    self.playerRetryFailMessage = payload.failMessage
                },

                hide() {
                    self.showPlayerPopup = false
                    self.playerPopupIcon = ''
                    self.playerPopupTitle = ''
                    self.playerPopupMessage = ''
                    self.playerOkButton = ''
                    self.playerRetryFailMessage = ''
                }
            }
        },

        isPromptReconnect () {
            return this.isReconnectPopup
        },

        onPlayerClickOk (button) {
            if (button.okButton == 'End Quiz') {
                window.onbeforeunload = function () {}
                window.location.href = '/join'
                return
            }
        },

        onMasterClickOk (button) {

            if (button.okButton == 'End Quiz') {
                window.onbeforeunload = function () {}
                window.location.href = '/edit/' + this.id + (this.isPlayTogether ? '?type=pt' : '')
            }
        },

        pauseTimeAndProgress () {
            if (this.$refs.quizHeader) {
                this.$refs.quizHeader.pauseProgress()
            }

            if (typeof this.pauseQuizTimeout == 'function') {
                this.pauseQuizTimeout()
            }
        },

        resumeTimeAndProgress () {
            if (this.$refs.quizHeader) {
                this.$refs.quizHeader.playProgress()
            }

            if (typeof this.resumeQuizTimeout == 'function') {
                this.resumeQuizTimeout()
            }
        }
    },

    destroyed () {
        window.removeEventListener('socket-reconnect', this.onSocketReconnect)
        window.removeEventListener('socket-reconnect-attempt', this.onSocketReconnectAttempt)

        if (this.watchUserTimer) {
            clearInterval(this.watchUserTimer)
        }

        if (this.watchMasterActiveTimer) {
            clearInterval(this.watchMasterActiveTimer)
        }

        this.showMasterPopup = false
        this.showPlayerPopup = false
    }
}
